import { Delete, Edit } from '@mui/icons-material';
import { IconMenu } from '../../../components';
import { Institution } from '../../../types/Institution';
import { useTranslations } from 'next-intl';
import { ROUTES } from '../../../../constants';
import { useNavigateTo } from '../../../hooks';

type Props = {
    institution: Institution;
};

export const InstitutionOptionsMenu = ({ institution }: Props) => {
    const navigateTo = useNavigateTo();
    const t = useTranslations('general');
    const onDelete = () => {
        alert('Option "Löschen" wird bald verfügbar sein');
    };

    return (
        <IconMenu
            items={[
                {
                    icon: <Edit />,
                    text: 'Profil bearbeiten',
                    onClick: () => navigateTo(ROUTES.EditInstitution)
                },

                {
                    icon: <Delete />,
                    text: `${t(institution.type)} löschen`,
                    onClick: onDelete
                }
            ]}
        />
    );
};
